import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  TextField as MuiTextField,
} from '@material-ui/core';
import { useRefresh, useNotify } from 'react-admin';
import { authPut } from '../../../server';

export function BulkChangeStatusModal({
  open,
  onClose,
  selectedIds,
  onSuccess,
}) {
  const [bulkStatus, setBulkStatus] = useState('');
  const [bulkReason, setBulkReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const refresh = useRefresh();
  const notify = useNotify();

  const requiresReason =
    bulkStatus === 'completed' || bulkStatus === 'dismissed';
  const reasonText = bulkReason.replace(/[^A-Za-z]/g, '');
  const isReasonValid = !requiresReason || reasonText.length >= 4;

  const handleClose = () => {
    setBulkStatus('');
    setBulkReason('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!bulkStatus || (requiresReason && !isReasonValid)) return;
    setSubmitting(true);
    const payload = {
      ids: selectedIds,
      status: bulkStatus,
    };
    if (requiresReason) {
      payload.completed_reason = bulkReason;
    }
    const response = await authPut('tasks/bulk-update', payload);
    setSubmitting(false);
    if (response?.error?.message) {
      notify(response.error.message, 'warning');
    } else {
      notify(`${selectedIds.length} task(s) updated`);
      refresh();
      handleClose();
      onSuccess && onSuccess();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>Bulk Change Status</DialogTitle>
      <DialogContent>
        <FormControl fullWidth style={{ marginBottom: 16 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={bulkStatus}
            onChange={e => setBulkStatus(e.target.value)}
            label='Status'
          >
            <MenuItem value='to do'>To do</MenuItem>
            <MenuItem value='in progress'>In progress</MenuItem>
            <MenuItem value='completed'>Completed</MenuItem>
            <MenuItem value='dismissed'>Dismissed</MenuItem>
          </Select>
        </FormControl>
        {requiresReason && (
          <MuiTextField
            label={`Reason for ${
              bulkStatus === 'completed' ? 'completion' : 'dismissal'
            }`}
            value={bulkReason}
            onChange={e => setBulkReason(e.target.value)}
            fullWidth
            multiline
            required
            error={bulkReason.length > 0 && !isReasonValid}
            helperText={
              bulkReason.length > 0 && !isReasonValid
                ? 'Reason must contain at least 4 letters'
                : ''
            }
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color='primary'
          disabled={
            !bulkStatus || (requiresReason && !isReasonValid) || submitting
          }
        >
          {submitting
            ? 'Updating...'
            : `Update ${selectedIds.length} task(s)`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
